// extracted by mini-css-extract-plugin
export default {"links":"Home_links__l5mzw","navLink":"Home_navLink__-MFrm","followUs":"Home_followUs__d-6u6","text":"Home_text__z-72W"};